<template>
  <img alt="First Central Insurance Logo" width="120" v-lazy="imgUrl" />
</template>

<script>
export default {
  name: "FirstCentralInsuranceLogo",
    data () {
    return {
      imgUrl:  require('@/assets/img/affiliates/firstcentralinsurance.png')
    }
  }
}
</script>

<style scoped>

</style>